import { render, staticRenderFns } from "./documentos-adjuntos.vue?vue&type=template&id=d6b76d3e&"
import script from "./documentos-adjuntos.vue?vue&type=script&lang=js&"
export * from "./documentos-adjuntos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports